import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
export function ComparisonTable() {
  const comparisons = [{
    feature: 'Precio',
    expensive: '$3,000-$8,000',
    alone: 'Gratis (pero...)',
    thisGuide: '$190 MXN'
  }, {
    feature: 'Tiempo a resultados',
    expensive: '3-6 meses',
    alone: '6-12 meses',
    thisGuide: '7-14 días'
  }, {
    feature: 'Info actualizada',
    expensive: 'Desactualizada',
    alone: 'No sabes qué es correcto',
    thisGuide: 'Actualizada 2024'
  }, {
    feature: 'Soporte',
    expensive: 'Limitado',
    alone: 'Estás sola',
    thisGuide: 'Grupo activo'
  }, {
    feature: 'Sistema claro',
    expensive: 'Mucha teoría',
    alone: 'Info dispersa',
    thisGuide: 'Paso a paso exacto'
  }, {
    feature: 'Garantía',
    expensive: 'Rara vez',
    alone: 'N/A',
    thisGuide: '30 días'
  }];
  return <section className="section-spacing bg-gradient-premium" data-id="element-203">
      <div className="container-premium" data-id="element-204">
        <div className="text-center mb-16" data-id="element-205">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-deep-cocoa mb-4" data-id="element-206">
            ¿Por qué elegir esta guía?
          </h2>
          <p className="text-lg text-deep-cocoa/70" data-id="element-207">
            Comparación honesta con tus otras opciones
          </p>
        </div>

        {/* Desktop Table */}
        <div className="hidden lg:block overflow-x-auto" data-id="element-208">
          <table className="w-full bg-white rounded-2xl shadow-premium overflow-hidden" data-id="element-209">
            <thead data-id="element-210">
              <tr className="bg-almond-milk" data-id="element-211">
                <th className="px-6 py-4 text-left text-deep-cocoa font-bold" data-id="element-212">
                  Característica
                </th>
                <th className="px-6 py-4 text-center text-deep-cocoa font-bold" data-id="element-213">
                  Cursos Caros
                </th>
                <th className="px-6 py-4 text-center text-deep-cocoa font-bold" data-id="element-214">
                  Hacerlo Sola
                </th>
                <th className="px-6 py-4 text-center bg-gradient-to-br from-cta-primary/10 to-cta-secondary/10 text-deep-cocoa font-bold" data-id="element-215">
                  Esta Guía ✨
                </th>
              </tr>
            </thead>
            <tbody data-id="element-216">
              {comparisons.map((row, index) => <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-almond-milk/30'} data-id="element-217">
                  <td className="px-6 py-4 font-semibold text-deep-cocoa" data-id="element-218">
                    {row.feature}
                  </td>
                  <td className="px-6 py-4 text-center text-deep-cocoa/70" data-id="element-219">
                    {row.expensive}
                  </td>
                  <td className="px-6 py-4 text-center text-deep-cocoa/70" data-id="element-220">
                    {row.alone}
                  </td>
                  <td className="px-6 py-4 text-center font-bold text-deep-cocoa bg-cta-primary/5" data-id="element-221">
                    {row.thisGuide}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        {/* Mobile Cards */}
        <div className="lg:hidden space-y-6" data-id="element-222">
          {comparisons.map((row, index) => <div key={index} className="bg-white rounded-2xl shadow-soft overflow-hidden" data-id="element-223">
              <div className="bg-almond-milk px-4 py-3" data-id="element-224">
                <h3 className="font-bold text-deep-cocoa" data-id="element-225">{row.feature}</h3>
              </div>
              <div className="p-4 space-y-3" data-id="element-226">
                <div className="flex items-start gap-3" data-id="element-227">
                  <XIcon className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-228" />
                  <div data-id="element-229">
                    <div className="text-xs text-deep-cocoa/60 mb-1" data-id="element-230">
                      Cursos Caros
                    </div>
                    <div className="text-sm text-deep-cocoa" data-id="element-231">
                      {row.expensive}
                    </div>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-232">
                  <XIcon className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-233" />
                  <div data-id="element-234">
                    <div className="text-xs text-deep-cocoa/60 mb-1" data-id="element-235">
                      Hacerlo Sola
                    </div>
                    <div className="text-sm text-deep-cocoa" data-id="element-236">{row.alone}</div>
                  </div>
                </div>
                <div className="flex items-start gap-3 bg-cta-primary/5 -mx-4 -mb-4 px-4 py-3" data-id="element-237">
                  <CheckIcon className="w-5 h-5 text-cta-primary flex-shrink-0 mt-0.5" data-id="element-238" />
                  <div data-id="element-239">
                    <div className="text-xs text-deep-cocoa/60 mb-1" data-id="element-240">
                      Esta Guía ✨
                    </div>
                    <div className="text-sm font-bold text-deep-cocoa" data-id="element-241">
                      {row.thisGuide}
                    </div>
                  </div>
                </div>
              </div>
            </div>)}
        </div>

        {/* Bottom CTA */}
        <div className="mt-12 text-center" data-id="element-242">
          <div className="inline-block bg-white rounded-2xl p-8 shadow-medium" data-id="element-243">
            <p className="text-xl font-bold text-deep-cocoa mb-2" data-id="element-244">
              La decisión es clara:
            </p>
            <p className="text-lg text-deep-cocoa/70 mb-6" data-id="element-245">
              Mejor precio, mejores resultados, menos tiempo
            </p>
            <a href="https://buy.stripe.com/dRm28rgfodEa83g1X618c00" className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-gradient-to-r from-cta-primary to-cta-secondary text-white font-bold rounded-xl shadow-glow-orange hover:shadow-xl hover:scale-105 transition-all duration-300" data-id="element-246">
              Sí, Quiero la Guía Ahora
            </a>
          </div>
        </div>
      </div>
    </section>;
}